import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function NHLECountyFilter({ setFilter, removeFilter, facets, filters }) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="county"
      filters={filters}
      id="county"
      label="County"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(NHLECountyFilter);
